// removed by extract-text-webpack-plugin
module.exports = {"flex":"RkRu7lUSV_90TgL3p_j7-","sticky":"_3Qc5ACBBNnUUWTxj1Pyaoc","container":"_3ELBi-T8Zhn92IuZJafkml","card":"_3qb2hnyzVTAI2dm8BAycdK","categoryLabel":"_2LPjYzkGCe5PiLFGmHlelz","selectedCategory":"_2XMlTyC0LopyD7lrNxR6FS","selectedCategoryIcon":"_1yEK4CZl0FBSaLgNVradnf","cardVideo":"_1gKw_LgvS_zfa4Diop27V2","contentVideo":"_1H42YF_IcNEn_sEcVlmS9H","selectedVideo":"_3XKOhWnaPB5sZKN7Ss6XeP","selectedVideoIcon":"_3sNekmw2SUTfEGU4_Lt4qZ","videoPlayWrapper":"_2EvcU3LUbvYn8hhHpMl5Sd"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/playlists/form/videos/video-chooser/VideoChooser.scss
// module id = 1650
// module chunks = 0